export function buildPeriodResolveQuery({ companyId, locationId, departmentId, startDate, endDate }) {
  const params = new URLSearchParams();
  if (companyId) params.set('company_id', companyId);
  if (locationId) params.set('location_id', locationId);
  if (departmentId) params.set('department_id', departmentId);
  params.set('start_date', startDate);
  params.set('end_date', endDate);
  params.set('period_type', 'WEEK');
  return params.toString();
}

export function buildPublicationPayload(
  period, viewStart, viewEnd, expectedStateToken, confirmWarnings, warningReason,
) {
  const full = period?.start_date === viewStart && period?.end_date === viewEnd;
  return {
    publication_type: full ? 'FULL' : 'PARTIAL',
    ...(full ? {} : { range_start: viewStart, range_end: viewEnd }),
    expected_state_token: expectedStateToken || '',
    confirm_warnings: confirmWarnings,
    warning_reason: warningReason,
  };
}

export function buildWeeklyDraftBatch(shifts, stateToken, viewStart, viewEnd, confirmWarnings, reason) {
  return {
    expected_state_token: stateToken || '',
    view_start: viewStart,
    view_end: viewEnd,
    items: shifts.map((shift, index) => ({
      ...(shift.id && !String(shift.id).startsWith('draft-') ? { id: shift.id } : {
        client_key: shift.client_key
          || String(shift.id || `draft-${shift.employee_id}-${shift.shift_date}-${shift.service_id || 'none'}-${index}`),
      }),
      employee_id: shift.employee_id,
      assignment_id: shift.assignment_id,
      service_id: shift.service_id,
      shift_date: shift.shift_date,
      start_time: shift.start_time,
      end_time: shift.end_time,
      break_minutes: Number(shift.break_minutes) || 0,
      notes: shift.notes || null,
      shift_type: shift.shift_type || 'LAVORO',
      status: shift.status || 'ACTIVE',
    })),
    confirm_warnings: confirmWarnings,
    reason,
  };
}